import axios from 'axios';


class MitRequestInterceptorService {
  constructor(userService, appRouter) {
    // Add a response interceptor
    axios.interceptors.response.use( (response) => {
      return response;
    }, (error) => {
      return new Promise((resolve, reject) => {
        if (error.response.status === 401 && userService.isLoggedIn()) {
          userService.clearCurrentUser()
          .then((res) => {
            window.location.href = '/';
            return reject(error);
          })
        }
        else if (error && error.response && error.response.status === 403) {
          //have logged in fine, but this user is not allowed access
          appRouter.push({name:'no-access'});
          return reject(error);
        }
        else{
          return reject(error);
        }
      });
    });
  }


}

export default MitRequestInterceptorService;
